import { Link } from 'react-router-dom'

type AppErrorPageProps = {
  eyebrow: string
  title: string
  description: string
  primaryAction: {
    label: string
    to: string
  }
  secondaryAction?: {
    label: string
    to: string
  }
  details?: string | null
}

export default function AppErrorPage({
  eyebrow,
  title,
  description,
  primaryAction,
  secondaryAction,
  details,
}: AppErrorPageProps) {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(21,183,158,0.16),_transparent_48%),linear-gradient(180deg,_#f8fffd_0%,_#eef6f7_100%)] px-6 py-10 text-slate-900">
      <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-4xl items-center justify-center">
        <div className="w-full rounded-[32px] border border-white/70 bg-white/90 p-8 shadow-[0_24px_80px_rgba(15,23,42,0.12)] backdrop-blur md:p-12">
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex rounded-full bg-brand-50 px-4 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-brand-700">
              {eyebrow}
            </span>
            <h1 className="mt-6 font-display text-3xl font-bold tracking-tight text-slate-950 md:text-5xl">
              {title}
            </h1>
            <p className="mt-4 text-base leading-7 text-slate-600 md:text-lg">{description}</p>
            {details ? (
              <p className="mt-4 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-500">
                {details}
              </p>
            ) : null}
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to={primaryAction.to}
                className="inline-flex min-w-40 items-center justify-center rounded-full bg-brand-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-brand-700"
              >
                {primaryAction.label}
              </Link>
              {secondaryAction ? (
                <Link
                  to={secondaryAction.to}
                  className="inline-flex min-w-40 items-center justify-center rounded-full border border-slate-200 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50"
                >
                  {secondaryAction.label}
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
